<ng-container *ngIf="!item.hidden">
  <!-- item with router url -->
  <a class="d-flex align-items-center" [ngClass]="item.classes" *ngIf="item.url && !item.externalUrl"
    [routerLink]="[item.url]" [target]="item.openInNewTab ? '_blank' : '_self'">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- item with external url -->
  <a class="d-flex align-items-center" [ngClass]="item.classes" *ngIf="item.url && item.externalUrl" [href]="item.url"
    [target]="item.openInNewTab ? '_blank' : '_self'">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <ng-template #itemContent>
    <span [data-feather]="item.icon" *ngIf="item.icon"></span>
    <span class="menu-title text-truncate">{{ item.translate ? (item.translate | translate) : item.title }}</span>
    <ng-container *ngIf="firmwareRelease.length > 0">
      <span class="badge ml-auto mr-1 badge badge-pill badge-light-danger" [ngbPopover]="popContent"
        placement="right" popoverTitle="Firmware Release" container="body" triggers="mouseenter:mouseleave">New
      </span>
      <ng-template #popContent>
        <p class="mb-0" *ngFor="let model of firmwareRelease">{{model}}</p>
      </ng-template>
    </ng-container>
  </ng-template>
</ng-container>